export const PDF_ROTATION_STEP_DEGREES = 90;

export const normalizePdfRotation = (rotationDegrees) => (
  ((Number(rotationDegrees) || 0) % 360 + 360) % 360
);

export const getNextPdfRotation = (rotationDegrees) => (
  normalizePdfRotation(Number(rotationDegrees) + PDF_ROTATION_STEP_DEGREES)
);
